import { Form, Modal } from 'antd'
import { t } from 'i18next'
import React, { useEffect } from 'react'
import { MessageTemplate } from '../message-template'
import { useUpdateMessageTemplate } from '../message-template-hooks'
import { MessageTemplateFormFields } from './message-template-form-fields'
import useForm from '../../hooks/use-form'

type MessageTemplateEditModalProps = {
    template: MessageTemplate | null
    onCancel: () => void
}

export function MessageTemplateEditModal({ template, onCancel }: MessageTemplateEditModalProps) {
    const updateTemplate = useUpdateMessageTemplate({ templateId: template?.id })

    const formProps = useForm({
        mutation: updateTemplate,
        onSuccess: () => {
            onCancel()
        },
    })

    useEffect(() => {
        if (!formProps.form.isFieldsTouched()) {
            formProps.form.setFieldsValue(template as never)
        }
    }, [template, formProps.form])

    return (
        <Modal
            title={t('Edit template')}
            open={!!template}
            onCancel={onCancel}
            confirmLoading={updateTemplate.isPending}
            onOk={() => {
                if (!template) {
                    return
                }

                formProps.form.submit()
            }}
            afterOpenChange={(isOpen) => {
                if (!isOpen || !template) {
                    formProps.form.resetFields()
                    return
                }
            }}
        >
            <Form
                {...formProps}
                layout="vertical"
            >
                <MessageTemplateFormFields />
            </Form>
        </Modal>
    )
}
